//--
import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';

const GetGlobalDataToken = () =>
    request({
        url: ApiURL.Query.GetGlobalDataToken,
        method: RequestType.GET,
    });

const GetSupportedCountries = (params: any) =>
    request({
        url: ApiURL.Query.GetSupportedCountries,
        method: RequestType.GET,
        params,
    });

const GetInstances = () =>
    request({
        url: ApiURL.Query.GetInstances,
        method: RequestType.GET,
    });

const GetCountries = () =>
    request({
        url: ApiURL.Query.GetCountries,
        method: RequestType.GET,
    });

const GetLanguages = () =>
    request({
        url: ApiURL.Query.GetLanguages,
        method: RequestType.GET,
    });

const GetSupportedLanguages = (params: any) =>
    request({
        url: ApiURL.Query.GetSupportedLanguages,
        method: RequestType.GET,
        params,
    });

const GetGlobaldataRedisData = (params: any): Promise<any> =>
    request({
        url: ApiURL.Query.GetGlobaldataRedisData,
        method: RequestType.GET,
        params,
    });
const GetSupportedCurrencies = (params: any) =>
    request({
        url: ApiURL.Query.GetSupportedCurrencies,
        method: RequestType.GET,
        params,
    });

const GetGlobaldataRedisKeyDetail = (databaseNumber: number, key: string): Promise<any> =>
    request({
        url: `${ApiURL.Query.GetGlobaldataRedisKeyDetail}/${databaseNumber}/${encodeURIComponent(key)}`,
        method: RequestType.GET,
    });

const GetGlobaldataDefaultDatabase = (): Promise<any> =>
    request({
        url: ApiURL.Query.GetGlobaldataDefaultDatabase,
        method: RequestType.GET,
    });

const GlobalDataQuery = {
    GetGlobalDataToken,
    GetInstances,
    GetSupportedCountries,
    GetCountries,
    GetSupportedLanguages,
    GetLanguages,
    GetGlobaldataRedisData,
    GetGlobaldataRedisKeyDetail,
    GetGlobaldataDefaultDatabase,
    GetSupportedCurrencies,
};

export default GlobalDataQuery;
